import React, { type ComponentProps } from "react";
import { AddBlockButton } from "./Button";
import { AddBlockModal } from "./Modal";
import useModal from "../../../../../../../../ui/lib/hooks/useModal";

export const AddBlock = ({
  dashboardId,
  blockId,
  blockPosition,
  onBlockAdded,
}: {
  dashboardId: string;
  blockId: string;
  blockPosition: [number, number, number, number];
  onBlockAdded?: ComponentProps<typeof AddBlockModal>["onBlockAdded"];
}) => {
  const { modal, openModal, closeModal } = useModal();
  return (
    <>
      <AddBlockButton
        onClick={e => {
          e.stopPropagation();
          openModal();
        }}
      />
      <AddBlockModal
        dashboardId={dashboardId}
        blockId={blockId}
        blockPosition={blockPosition}
        opened={modal}
        onBlockAdded={onBlockAdded}
        onRequestClose={() => closeModal()}
      />
    </>
  );
};
